import React, {Fragment} from 'react';
import loadable from '@loadable/component';
import {
    CACHE as LOADING_CACHE,
    placeholderFromType,
} from '../../components/common/loading';

const DestinationInfographicLoadable = loadable(
    () =>
        import(
            /* webpackChunkName: "destination-infographic" */
            /* webpackPrefetch: true */
            './'
        ),
    {ssr: false}
);

export const AsyncDestinationInfographic = () => {
    const componentPlaceholder = placeholderFromType(
        AsyncDestinationInfographic
    ); // eslint-disable-line no-use-before-define

    const element = (
        <DestinationInfographicLoadable
            fallback={<Fragment>{componentPlaceholder}</Fragment>}
        />
    );

    return element;
};

AsyncDestinationInfographic.displayName = 'AsyncDestinationInfographic';

LOADING_CACHE.set(AsyncDestinationInfographic, {
    componentType: 'AsyncDestinationInfographic',
    placeholderType: 'Infographic',
    size: 'xlg',
});
